module.exports = __webpack_public_path__ + "static/guidelines-90821e7c2d5785824bfc330a894f5950.jpeg";